import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [props: string]: any
}

export const PostWappIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', ...sx }}
    {...props}
  >
    <path
      d="M19 15V5H5v10h14ZM3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm9 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8ZM6 6h2v2H6V6Zm0 11v2h12v-2H6Z"
      fill="url(#PostWappIcon)"
    />
    <defs>
      <linearGradient
        id="PostWappIcon"
        x1="4.21"
        y1="16.5"
        x2="19.79"
        y2="7.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FA4545" />
        <stop offset="1" stopColor="#F57073" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

PostWappIcon.defaultProps = {
  sx: null,
}
